import { types as actions } from '../actions';

const defaultState = {
  list: [],
  currentWorkflow: {}
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.SET_WORKFLOWS:
      return {
        ...state,
        list: action.workflows
      };
    case actions.ADDED_WORKFLOW:
      let found = state.list.find(
        workflow => workflow.id === action.workflow.id
      );
      return {
        ...state,
        list: found ? state.list : [...state.list, action.workflow]
      };
    case actions.SET_CURRENT_WORKFLOW:
      return {
        ...state,
        currentWorkflow: action.workflow
      };
    case actions.EDITED_WORKFLOW:
      return {
        ...state,
        list: state.list.map(
          workflow =>
            workflow.id === action.workflow.id ? action.workflow : workflow
        )
      };
    case actions.REMOVE_WORKFLOW:
      return {
        ...state,
        list: state.list.filter(workflow => workflow.id !== action.workflow.id)
      };
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/workflows/index.js